import { render, staticRenderFns } from "./CommonAlert2.vue?vue&type=template&id=f1943b86&scoped=true&"
import script from "./CommonAlert2.vue?vue&type=script&lang=js&"
export * from "./CommonAlert2.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlert2.vue?vue&type=style&index=0&id=f1943b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1943b86",
  null
  
)

export default component.exports